import { InputBaseClassKey } from '@material-ui/core/InputBase';

const MuiInputBase = (): Partial<Record<InputBaseClassKey, unknown>> => ({
    root: {
        '&:not($marginDense) $inputHiddenLabel': {
            paddingTop: 14.5,
            paddingBottom: 14.5,
            '&$inputMultiline': {
                paddingTop: 0,
                paddingBottom: 0,
            },
        },
    },
});

export default MuiInputBase;
